'use client';

import { useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Skip PostHog in non-production to avoid proxy errors
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    if (!posthogKey) {
      console.warn('PostHog key not found');
      return;
    }

    // Only initialize if not already initialized
    if (!posthog.__loaded) {
      posthog.init(posthogKey, {
        api_host: '/ingest',
        ui_host: 'https://us.posthog.com',
        capture_exceptions: true,
        person_profiles: 'always',
      });
    }
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
